import React, { useState, useRef, useEffect } from "react";
import "./EATooltip.scss";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";

interface IProps {
  content: React.ReactNode; // Tooltip content
  children: React.ReactNode; // The element to hover over
  position?: "top" | "right" | "bottom" | "left";
  fullWidth?: boolean; // Nowy prop dla court grid
}

const EATooltip: React.FC<IProps> = ({ content, children, position = "top", fullWidth = false }) => {
  const [visible, setVisible] = useState(false);
  const [clickedOnMobile, setClickedOnMobile] = useState(false);
  const isDesktop = useDesktopSize();
  const wrapperRef = useRef<HTMLDivElement>(null);

  // Handle click outside to close tooltip on mobile
  useEffect(() => {
    if (!isDesktop && clickedOnMobile) {
      const handleClickOutside = (event: MouseEvent) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
          setClickedOnMobile(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [clickedOnMobile, isDesktop]);

  const handleClick = () => {
    if (!isDesktop) {
      setClickedOnMobile(!clickedOnMobile);
    }
  };

  const shouldShowTooltip = content && (isDesktop ? visible : clickedOnMobile);

  return (
    <div
      ref={wrapperRef}
      className={`tooltip-wrapper ${fullWidth ? "tooltip-wrapper--full-width" : ""}`}
      onMouseEnter={() => isDesktop && setVisible(true)}
      onMouseLeave={() => isDesktop && setVisible(false)}
      onFocus={() => isDesktop && setVisible(true)}
      onBlur={() => isDesktop && setVisible(false)}
      onClick={handleClick}
    >
      {children}
      {shouldShowTooltip && (
        <div className={`tooltip-box tooltip-${position} ${!isDesktop ? 'tooltip-box--mobile-active' : ''}`} role="tooltip">
          {content}
        </div>
      )}
    </div>
  );
};

export default EATooltip;
